import {ILayersDispatcher} from '../core/interfaces/dispatchers'

import {LayersDispatcher} from '../core/dispatchers/layersDispatcher'

export class AppLayersDispatcher extends LayersDispatcher {}

export const appLayersDispatcher = new AppLayersDispatcher() as ILayersDispatcher
